import { AxiosInstance } from "axios";
import {
  ActionPlanPreferences,
  ActivityResponse,
  ScheduledTrainingModule,
} from "../types/actionPlan";
import { getApiClient } from "../utils/api.utils";

export class ActionPlanService {
  client: AxiosInstance;

  constructor() {
    this.client = getApiClient();
  }

  getActivitySuggestions = async (data: ActionPlanPreferences) => {
    const response = await this.client.post<ActivityResponse[]>(
      "/action-plan/activities/suggestions/",
      data
    );
    return response.data;
  };

  getActivityTrainingModuleSuggestions = async (
    data: ScheduledTrainingModule[]
  ) => {
    const response = await this.client.post<ActivityResponse[]>(
      "/action-plan/activities/suggestions/training-module/",
      { training_suggestions: data }
    );
    return response.data;
  };

  createActivities = async (activities: ActivityResponse[]) => {
    const createdActivities: ActivityResponse[] = [];

    for (const activity of activities) {
      const response = await this.client.post<ActivityResponse>(
        "/action-plan/activities/",
        activity
      );
      createdActivities.push(response.data);
    }

    return createdActivities;
  };

  getActivities = async () => {
    const response = await this.client.get<ActivityResponse[]>(
      "/action-plan/activities/"
    );
    return response.data;
  };

  updateActivity = async (activity: ActivityResponse) => {
    const response = await this.client.put<ActivityResponse>(
      `/action-plan/activities/${activity.id}`,
      activity
    );
    return response.data;
  };

  deleteActivity = async (activity: ActivityResponse) => {
    const response = await this.client.delete<void>(
      `/action-plan/activities/${activity.id}`
    );
    return response.data;
  };
}
